import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const PartnerLogoContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    &.hide {
        visibility: hidden;
    }
`;
const PartnerLogoElement = styled.img`
    max-width: 111px;
    max-height: 24px;
`;
const PublisherLogo = props => (
    <PartnerLogoContainer>
        <PartnerLogoElement src={props.logoUrl} alt="" onClick={props.onClick} />
    </PartnerLogoContainer>
);

PublisherLogo.propTypes = {
    logoUrl: PropTypes.string,
    onClick: PropTypes.func
};

export default PublisherLogo;
